import * as React from 'react'

function BusinessChartSearch(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 10a4 4 0 100-8 4 4 0 000 8zM21 11l-2.172-2.172M16 21h2a3 3 0 003-3v-3M3 11V7a3 3 0 013-3h2M3 17.25h3V21H3v-3.75zM6 13h3v8H6v-8zM9 15.25h3V21H9v-5.75z"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { BusinessChartSearch }
